import { MenuItem } from '../config/menuItems';

export const filterMenuItems = (menuItems: MenuItem[], isUsedMealCard: boolean | null): MenuItem[] => {
  return menuItems.map((menuItem) => {
    if (menuItem.title === 'Kart') {
          // Eğer isUsedMealCard null veya false ise, Yemek Kartı ve Bakiye Yükleme Talimatları menülerini çıkar
          if (isUsedMealCard === null || isUsedMealCard === false) {
            const filteredChildren = menuItem.children?.filter(
              (child) => 
                child.title !== 'Yemek Kartı' && 
                child.title !== 'Bakiye Yükleme Talimatları'
            );
            
            return {
              ...menuItem,
              children: filteredChildren
            };
          }
        }
        return menuItem;
      });
};